import { TradeDisplayValues, Side } from '../shared';
import { Drfq, DrfqKind, DrfqVenueCode, QuoteCurrency, Role } from './domain';

/** Null if trade was successfully settled */
export type TradeRejectParty = 'USER' | 'COUNTERPARTY' | null;

type DrfqTradeState = 'FILLED' | 'PENDING_SETTLEMENT' | 'REJECTED';

export interface Trade {
  readonly rfqType: 'drfq';
  readonly id: string;
  readonly exec_id: string;
  readonly order_id: string;
  readonly rfq_id: Drfq['id'];
  readonly venue: DrfqVenueCode;
  readonly kind: DrfqKind;
  readonly state: DrfqTradeState;
  readonly role: Role;
  readonly side: Side;
  readonly price: string;
  readonly mark_price: string;
  readonly quantity: string;
  readonly description: string;
  readonly strategy_description: string;
  readonly filled_quantity: string;
  readonly legs: readonly TradeLeg[];
  readonly rejected_quantity: string;
  readonly rejected_party: TradeRejectParty;
  /** Null if trade was successfully settled */
  readonly rejected_reason: string | null;
  /** Desk ticker of the other side; null when anonymous. */
  readonly counterparty: string | null;
  readonly quote_currency: QuoteCurrency;
  readonly executed_at: Date;
  readonly filled_at: Date;
  readonly displayValues: TradeDisplayValues;
  readonly account: string;
}

export interface TradeLeg {
  readonly instrument_id: number;
  readonly venue_trade_id: string;
  readonly instrument_name: string;
  readonly side: Side;
  readonly product_code: string;
  readonly quantity: string;
  readonly price: string;
  readonly fee_quantity: string;
  readonly fee_currency: string;
  readonly ratio: string;
  readonly isHedge: boolean;
}

export interface TradeTapeItem {
  readonly rfqType: 'drfq';
  readonly id: string;
  readonly rfq_id: Drfq['id'];
  readonly venue: DrfqVenueCode;
  readonly kind: DrfqKind;
  readonly state: DrfqTradeState;
  readonly side: Side;
  readonly price: string;
  readonly mark_price: string;
  readonly quantity: string;
  readonly description: string;
  readonly strategy_description: string;
  readonly legs: readonly TradeTapeLeg[];
  readonly quote_currency: QuoteCurrency;
  readonly executed_at: Date;
  readonly filled_at: Date;
  readonly strategy_code: string;
  readonly displayValues: TradeDisplayValues;
}

export interface TradeTapeLeg {
  readonly instrument_id: number;
  readonly instrument_name: string;
  readonly side: Side;
  readonly quantity: string;
  readonly price?: string;
  readonly product_code: string;
  readonly ratio: string;
  readonly isHedge: boolean;
}

export const isFilledTrade = (trade: Trade | TradeTapeItem) =>
  trade.state === 'FILLED';
export const isRejectedTrade = (trade: Trade | TradeTapeItem) =>
  trade.state === 'REJECTED';
export const isTradeHistoryItem = (
  trade: Trade | TradeTapeItem,
): trade is Trade => 'rejected_quantity' in trade;
